import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, taught the theme's own names (src/styles/theme.css). Without
 * this it keeps both of two clashing custom classes, `rounded-control
 * rounded-full` or `type-h5 type-h4`, and the stylesheet's order decides which
 * one wins instead of the caller.
 */
const twMerge = extendTailwindMerge<'type-rung' | 'content-width'>({
  extend: {
    theme: {
      radius: ['control', 'card', 'dialog', 'item', 'xsmall', 'small', 'medium', 'large', 'xlarge', '2xlarge', 'max'],
      shadow: ['low', 'mid', 'high'],
      text: ['2xs', 'h1', 'h2', 'h3', 'h4', 'h5'],
    },
    classGroups: {
      'type-rung': [{ type: ['h1', 'h2', 'h3', 'h4', 'h5'] }],
      'content-width': [{ col: ['s', 'm', 'w'] }],
    },
    conflictingClassGroups: {
      'type-rung': ['font-size', 'leading', 'font-family', 'font-weight'],
      'content-width': ['max-w', 'w'],
    },
  },
});

/** Joins class names and lets a later Tailwind class win over an earlier one. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
